import { BulkCreateSpacecontrolBookingDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'

export const useCreateSpaceBooking: OneCreationActionResolver = () => {
  const { employee } = useCurrentSession()

  const [createBooking, { loading }] = useMutation(BulkCreateSpacecontrolBookingDocument, {
    extractorFn: (data) => data.spaceControlMutations.bulkCreateSpacecontrolBooking,
    errorPolicy: 'all',
  })

  const createBookingHandler = async (args: {
    workSpaceId: string
    date: string
    slots?: number[] | null
    employeeId?: string | null
  }) => {
    const employeeId = args.employeeId ?? employee?.id
    if (!employeeId) {
      return
    }

    const result = await createBooking({
      variables: {
        employeeId: String(employeeId),
        workSpaceId: String(args.workSpaceId),
        date: args.date,
        slots: args.slots == null || args.slots.length === 0 ? [1] : args.slots,
      },
    })

    return handleResult(result, (_errors) => {})
  }

  return {
    resolver: createBookingHandler,
    loading,
  }
}
